import {
    DonationProcessBarWrapper,
    DonationProcessBarCol,
    DonationProcessP,
    DottedLine,
    IconCircleWrapper,
    DonationProcessBarH2,
    DonationProcessBarContainer
} from "./DonationProcessBar.styles";

function DonationProcessBar() {
  return (
    <DonationProcessBarContainer>
      <DonationProcessBarH2>How does this work?</DonationProcessBarH2>
      <DonationProcessBarWrapper>
        <DonationProcessBarCol>
          <IconCircleWrapper>
            <i className="fa-solid fa-circle-dollar-to-slot" />
          </IconCircleWrapper>
          <DonationProcessP>Donate</DonationProcessP>
        </DonationProcessBarCol>
        
        <DonationProcessBarCol><DottedLine /></DonationProcessBarCol>
        
        <DonationProcessBarCol>
          <IconCircleWrapper>
            <i className="fa-solid fa-hand-holding-dollar" />
          </IconCircleWrapper>
          <DonationProcessP>Received</DonationProcessP>
        </DonationProcessBarCol>
        
        <DonationProcessBarCol><DottedLine /></DonationProcessBarCol>
        
        <DonationProcessBarCol>
          <IconCircleWrapper>
            <i className="fa-solid fa-play" style={{paddingLeft: "7.5px"}} />
          </IconCircleWrapper>
          <DonationProcessP>Start</DonationProcessP>
        </DonationProcessBarCol>
        
        <DonationProcessBarCol><DottedLine /></DonationProcessBarCol>
        
        <DonationProcessBarCol>
          <IconCircleWrapper>
            <i className="fa-solid fa-magnifying-glass" />
          </IconCircleWrapper>
          <DonationProcessP>Check</DonationProcessP>
        </DonationProcessBarCol>

        <DonationProcessBarCol><DottedLine /></DonationProcessBarCol>
        
        <DonationProcessBarCol>
          <IconCircleWrapper>
            <i className="fa-solid fa-circle-check" />
          </IconCircleWrapper>
          <DonationProcessP>Finish</DonationProcessP>
        </DonationProcessBarCol>
      </DonationProcessBarWrapper>
    </DonationProcessBarContainer>
  )
}

export default DonationProcessBar;
